import TotalTransactionsIcon from "../components/dashboard/icons/TotalTransactions";
import { useState } from "react";
import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const TotalTransactions = ({ data }) => {
  const [totalTransByTime, setTotalTransByTime] = useState("0");
  const [totalTransByUnit, setTotalTransByUnit] = useState("0");
  const [totalTransByPrice, setTotalTransByPrice] = useState("0");
  const { selectedFacility } = useSelector((state) => state.stationList);
  const { selectedDate } = useSelector((state) => state.datePicker);
  const [loading, setLoading] = useState(true);

  const { t } = useTranslation();

  useEffect(() => {
    setLoading(true);
    if (data?.view_facility_revenue_aggregate?.nodes) {
      let sessionByTime = data?.view_facility_revenue_aggregate?.nodes.reduce(
        (prev, cur) => prev + Number(cur.session_by_time),
        0
      );
      let sessionByUnit = data?.view_facility_revenue_aggregate?.nodes.reduce(
        (prev, cur) => prev + Number(cur.session_by_unit),
        0
      );
      let sessionByPrice = data?.view_facility_revenue_aggregate?.nodes.reduce(
        (prev, cur) => prev + Number(cur.session_by_price),
        0
      );
      sessionByTime = sessionByTime === 0 ? "0" : sessionByTime.toFixed(0);
      sessionByUnit = sessionByUnit === 0 ? "0" : sessionByUnit.toFixed(0);
      sessionByPrice = sessionByPrice === 0 ? "0" : sessionByPrice.toFixed(0);
      setTotalTransByTime(Number(sessionByTime).toLocaleString());
      setTotalTransByUnit(Number(sessionByUnit).toLocaleString());
      setTotalTransByPrice(Number(sessionByPrice).toLocaleString());
    }
    setLoading(false);
  }, [data, selectedFacility, selectedDate]);

  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      bgcolor={"white"}
      justifyContent={"space-between"}
      borderRadius={"16px"}
      padding={"24px"}
      height="150px"
    >
      <Typography>
        <Typography
          variant="subtitle"
          fontSize="12px"
          fontWeight="600"
          style={{ textWrap: "nowrap" }}
        >
          {t("totalTransactions")}
          {loading ? (
            <span style={{ color: "#467CEB" }}> {t("loading")}...</span>
          ) : (
            ""
          )}
        </Typography>
        <Typography
          variant="h6"
          fontSize="18px"
          fontWeight="700"
          style={{ textWrap: "nowrap" }}
        >
          {totalTransByTime} <span style={{ fontSize: "12px" }}>by Time</span>
        </Typography>
        <Typography
          variant="h6"
          fontSize="18px"
          fontWeight="700"
          style={{ textWrap: "nowrap" }}
        >
          {totalTransByUnit} <span style={{ fontSize: "12px" }}>by Unit</span>
        </Typography>
        <Typography
          variant="h6"
          fontSize="18px"
          fontWeight="700"
          style={{ textWrap: "nowrap" }}
        >
          {totalTransByPrice} <span style={{ fontSize: "12px" }}>by Price</span>
        </Typography>
      </Typography>
      <TotalTransactionsIcon />
    </Box>
  );
};
export default TotalTransactions;
